import React from 'react'
import ReservationCheckInTypeItem from './ReservationCheckInTypeItem'
import SearchField from './SearchField'

export default ({
  reservations = [],
  onReservationSelect,
  filterText,
  onFilterTextChange,
}) => (
  <div className="flex flex-col h-full">
    <div className="mb-4">
      <SearchField
        value={filterText}
        onChange={onFilterTextChange}
        placeholder="Search reservations..."
      />
    </div>
    <div className="flex-1 overflow-y-auto">
      {renderReservationItems(reservations, onReservationSelect, filterText)}
    </div>
  </div>
)

const renderReservationItems = (
  reservations,
  onReservationSelect,
  filterText,
) => {
  if (filterText && reservations.length <= 0)
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <svg
          className="w-16 h-16 text-gray-300 mb-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
          />
        </svg>
        <h3 className="text-gray-900 font-medium text-lg mb-1">
          No reservations found
        </h3>
        <p className="text-gray-500 text-sm">
          Try adjusting your search criteria
        </p>
      </div>
    )

  if (reservations.length <= 0)
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <svg
          className="w-16 h-16 text-gray-300 mb-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        <h3 className="text-gray-900 font-medium text-lg mb-1">
          Search for reservations
        </h3>
        <p className="text-gray-500 text-sm max-w-xs">
          Enter a confirmation number, or guest name to find reservations
        </p>
      </div>
    )

  return reservations.map((reservation) => (
    <ReservationCheckInTypeItem
      key={reservation.id}
      reservation={reservation}
      onClick={onReservationSelect}
    />
  ))
}
